const Logo = ({ size = 40, className = "" }) => (
  <img
    src="/logo-mark.jpg"
    alt="Monogramme Gabana Management"
    width={size}
    height={size}
    className={`object-contain mix-blend-screen ${className}`}
    aria-hidden="true"
  />
);

export default Logo;
